var TreasureBoxItem = require("activity/TreasureBox/TreasureBoxItem.js")
var TreasureBoxBigItem = require("activity/TreasureBox/TreasureBoxBigItem.js")
var TreasureBoxManager = require("activity/TreasureBox/TreasureBoxManager.js")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
require("clover/panel/component/common/UIGroupButton")
require("clover/panel/base/BasePanel")
var TreasureBoxPanel = xClass("TreasureBoxPanel", BasePanel, function () {
    // return cc.CSLoader.createNode("cocos/prop_bag_panel_BagPanel.csb")
    return new cc.Node()
})
TreasureBoxPanel.isOpened = false
TreasureBoxPanel.resources = ["packed/TreasureBoxRes.pack"]
TreasureBoxPanel.show = function (onSuccess, onFail) {
    var loadId = LoadingPanelLogic.getInstance().add()
    function success() {
        let panel = TreasureBoxPanel.create()
        panel.popup(true)
        TreasureBoxPanel.isOpened = true
        LoadingPanelLogic.getInstance().remove(loadId)
        onSuccess && onSuccess(panel)
    }
    var ok_res = false
    var ok_info = false
    function resFunc() {
        ok_res = true
        if(ok_res && ok_info) {success()}
    }

    function infoFunc() {
        ok_info = true
        if(ok_res && ok_info) {success()}
    }

    preloadWithLoading(TreasureBoxPanel.resources, resFunc, function () {
        Toast.make(getText("error.tip.load_res_error"))
        onFail && onFail();
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        LoadingPanelLogic.getInstance().remove(loadId)
        onFail && onFail()
    }, true)

    TreasureBoxManager.getInstance().getInfo(function() {
        infoFunc()
    }, function () {
        Toast.make(getText("error.tip.load_res_error"))
        LoadingPanelLogic.getInstance().remove(loadId)
        onFail && onFail()
    })
}
TreasureBoxPanel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)

    //bg
    var bg = ccui.Scale9Sprite.createWithSpriteFrameName("treasureBox/bg.png", cc.rect(270, 121, 150, 121))
    bg.setScale9Enabled(true)
    bg.setPreferredSize(cc.size(690, 1040))
    self.addChild(bg)
    bg.setPosition(0,-60)
    self.bg = bg
    //bg2
    var bg2 = ccui.Scale9Sprite.createWithSpriteFrameName("treasureBox/bg2.png", cc.rect(70, 60, 490, 36))
    bg2.setScale9Enabled(true)
    bg2.setPreferredSize(cc.size(633, 597))
    self.addChild(bg2)
    bg2.setPosition(0,-195)
    self.bg2 = bg2
    //title  720    1280   360 640
    var titleImg = cc.Sprite.createWithSpriteFrameName("treasureBox/title.png")
    self.addChild(titleImg)
    titleImg.setPosition(0, 640 - 222)

    var titleImg2 = cc.Sprite.createWithSpriteFrameName("treasureBox/banner.png")
    self.addChild(titleImg2)
    titleImg2.setPosition(0, 640 - 390)

    // var closeSp = cc.Sprite.createWithSpriteFrameName("uilibrary/off_btn_light.png")
    var closeSp = cc.Sprite.createWithSpriteFrameName("uilibrary/close_idle.png")
    closeSp.setPosition(0, 0)
    var closeBtn = UIGroupButton.create(closeSp)  	
    self.addChild(closeBtn)
    closeBtn.setPosition(315, 434)
    closeBtn.setScale(1)
    closeBtn.on(UIButtonEvent.Click, function () {
        self.onClose()
    })
    self.closeBtn = closeBtn
    ButtonPushBounceAnim.create(closeBtn)
    //help
    var helpIcon = cc.CSLoader.createNode("cocos/treasureBox_btn_question.csb")
    var helpBtn = UIGroupButton.create(helpIcon)  	
    self.addChild(helpBtn)
    self.helpBtn = helpBtn
    helpBtn.setPosition(140, 418)
    helpBtn.setScale(0.7)
    helpBtn.on(UIButtonEvent.Click, function () {
        self.openQuesPanel()
    })
    ButtonPushBounceAnim.create(helpBtn)
    
    self.showItems()
    self.showBigItem()

    if (!MetaManager.isUseRealShareOnSpecialModule("redbag")) {
        let GameGuideAnims = require("clover/gameGuide/GameGuideAnims")
        var str = "{c=250,234,135,255}新玩家{c=255,255,255,255}点击获得{c=250,234,135,255}3倍奖励"
        var descTxt = GameGuideAnims.createMixedText(str, 27, cc.color.WHITE, 500, "center")
        var newSize = HeDisplayUtil.getNodeGroupBounds(descTxt, null)
        descTxt.setAnchorPoint(cc.p(0.5, 0.5))
        descTxt.setPosition(-249, -515)
        self.descTxt = descTxt
        self.addChild(descTxt)
    }
    TreasureBoxManager.getInstance().setTreasurePanel(self)

    const Event = require("hecore/EventDispatcher").Event;
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterPanel,
        {
            id: WelfareCenterId.treasureBox,
        }))
}

TreasureBoxPanel.prototype.showItems = function() {
    var self = this
    self.itemArr = []
    //(160, 690) (358,690) (555,690) (160,973) (358,973) (555,973)
    var x1 = 160 - 360
    var x2 = 0
    var x3 = 555 - 360
    var y1 = 640 - 690
    var y2 = 640 - 973
    var posArr = [{x:0,y:0},{x:x1,y:y1}, {x:x2,y:y1}, {x:x3,y:y1}, 
                  {x:x1,y:y2}, {x:x2,y:y2}, {x:x3,y:y2}]
    var data = TreasureBoxManager.getInstance().getData()
    var arr = data.bags;
    if(arr) {
        for(var i=1;i<=5;i++) {
            let item = TreasureBoxItem.create()
            self.addChild(item)
            item.setPosition(posArr[i])
            item.showByData(arr[i])
            self.itemArr.push(item)
        }
    }
    
}
TreasureBoxPanel.prototype.showBigItem = function() {
    var self = this
    self.bigItem = TreasureBoxBigItem.create()
    self.addChild(self.bigItem)
    self.bigItem.setPosition(555 - 360, 640 - 973)
    var data = TreasureBoxManager.getInstance().getData()
    self.bigItem.setData(data);
    
}

TreasureBoxPanel.prototype.openQuesPanel = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true

    let complete = ()=> self.isBusy = false;
    let [QuesPanel, PanelEvent] = require("clover/panel/CommonQuesPanel");
    if (MetaManager.isUseRealShareOnSpecialModule("redbag")) {
        QuesPanel.show(
            getText("helper.treasrebox.title"), 
            getText("helper.treasrebox.content.realshare"), 
            getText("helper.treasrebox.surebtn.key"),
            true,
            (panel) => {
                panel.on(PanelEvent.Close, () => {
                    panel.onClose();
                    complete();
                });
                panel.popup(true, false);
            }, complete, complete);
    } else {
        QuesPanel.show(
            getText("helper.treasrebox.title"), 
            getText("helper.treasrebox.content"), 
            getText("helper.treasrebox.surebtn.key"),
            true,
            (panel) => {
                panel.on(PanelEvent.Close, () => {
                    panel.onClose();
                    complete();
                });
                panel.popup(true, false);
            }, complete, complete);
    }
}

TreasureBoxPanel.prototype.refresh = function() {
    var self = this
    
    TreasureBoxManager.getInstance().getInfo(function() {
        let data = TreasureBoxManager.getInstance().getData()
        let arr = data.bags;
        if(arr && self.itemArr && self.itemArr.length>4) {
            for(let i=1;i<=5;i++) {
                let item = self.itemArr[i-1]
                item.showByData(arr[i])
            }
        }

        if(self.bigItem) {
            self.bigItem.setData(data);
        }
    })
}
TreasureBoxPanel.prototype.onClose = function () {
    var self = this
    TreasureBoxPanel.isOpened = false
    // body
    // var TreasureBoxButton = require("activity/TreasureBox/TreasureBoxButton.js")
    // TreasureBoxButton.updateState()
    TreasureBoxManager.getInstance().getInfo(function () {
        const Event = require("hecore/EventDispatcher").Event;
        GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
            {
                id: WelfareCenterId.treasureBox,
                redDot: TreasureBoxManager.getInstance().isHaveReward() || false,
            }))
    })
    BasePanel.prototype.onClose.call(self)
}
TreasureBoxPanel.prototype.onCleanup = function () {
    ResManager.release(TreasureBoxPanel.resources)
}

TreasureBoxPanel.prototype.onEnterAnimFinish = function() {
    let self = this;
    BasePanel.prototype.onEnterAnimFinish.call(self);

    DCAssist.dc4ShareShow("treasure_box");
}

module.exports = TreasureBoxPanel